<template>
  <div class="vipProductList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button
        type="primary"
        size="small"
        @click="vipOperation('add', tableData)"
        class="add-input"
        >+新增商品权益配置</el-button
      >
      <el-button
          type="primary"
          size="small"
          @click="getProductList()"
          class="add-input"
          style="margin-right: 10px;"
      >刷新</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      height="700"
      size="small"
      v-loading="loading"
      element-loading-text="拼命加载中"
      @sort-change="handleSortChange"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column
        prop="productName"
        label="特权"
        align="center"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.privilegeName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="privilegeDesc"
        label="特权描述"
        align="center"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.privilegeDesc }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="privilegeDesc"
        label="排序"
        align="center"
        fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.sort }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="cover"
        label="图标"
        align="center"
      >
        <template slot-scope="scope">
          <img-load
            :key="scope.row.img"
            :src="imgUrl +'/' + scope.row.img"
            :height="'32px'"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="vipOperation('edit', scope.row)"
          >修改</el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="removeAdmin(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination
      :page-sizes="[10, 15, 20, 25]"
      :current-page="param.pageNumber"
      :page-size="param.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"

      style=" margin-top: 10px;padding-bottom: 30px;"
      @current-change="changeCurrent"
    ></el-pagination> -->
    <!--新增、编辑弹框-->
    <vip-action
      ref="addVip"
      @handlerProductList="handlerProductList"
    ></vip-action>
  </div>
</template>
<script>
import API from "@/api";
import {sortEscape} from "@/utils/global";
import VipAction from "./components/vipAction";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      imgUrl: baseConfig.imgUrl,
      tableData: [],
      total: 0,
      // VIP商品列表请求参数
      param: {
         pageNumber: 1,
         pageSize: 50,
      },
    };
  },
  components: {
    VipAction,
  },
  created() {
    this.getProductList(this.param);
  },
  methods: {
    // 请求商品列表
    getProductList() {
      this.loading = true;
      API.privilegeList(this.param)
        .then((res) => {
          this.tableData = [];
          if (res.code === 200 && res.data.length > 0) {
            this.tableData = res.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 数据排序
    handleSortChange(column) {
      this.param.value = sortEscape(column.order);
      this.param.key = column.prop;
      this.getProductList(this.param);
    },
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getProductList();
    },
    // 删除管理员
    removeAdmin(row) {
      this.$confirm("您确定要删除当前商品吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.deleteProduct({ id: row.id }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getProductList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 新增、编辑操作
    vipOperation(type, data) {
      this.$refs.addVip.open(type, data);
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerProductList() {
      this.getProductList();
    },
  },
};
</script>

<style lang="scss">
.add-input {
  margin-left: 0 !important;
}
</style>
